export interface AppEnv {
  apiOrigin: string;
  appVersion: string;
  botUsername: string;
  configError: string | null;
  configWarning: string | null;
}

function normalizeApiOrigin(rawValue: string): Pick<AppEnv, "apiOrigin" | "configError" | "configWarning"> {
  const raw = rawValue.trim();

  if (!raw) {
    return {
      apiOrigin: "",
      configError: "缺少 VITE_API_BASE_URL，前端无法连接 Worker API。",
      configWarning: null,
    };
  }

  try {
    const parsed = new URL(raw);
    const warning =
      parsed.pathname !== "/" || parsed.search || parsed.hash
        ? "VITE_API_BASE_URL 只应填写 Worker 公开源站 origin，已自动忽略路径、查询与 hash。"
        : null;

    return {
      apiOrigin: parsed.origin,
      configError: null,
      configWarning: warning,
    };
  } catch {
    return {
      apiOrigin: "",
      configError: "VITE_API_BASE_URL 不是合法 URL，请只填写 Worker 公开 origin。",
      configWarning: null,
    };
  }
}

const api = normalizeApiOrigin(String(import.meta.env.VITE_API_BASE_URL ?? ""));

export const ENV: AppEnv = {
  apiOrigin: api.apiOrigin,
  appVersion: String(import.meta.env.VITE_APP_VERSION ?? "0.1.0").trim() || "0.1.0",
  botUsername: String(import.meta.env.VITE_BOT_USERNAME ?? "")
    .trim()
    .replace(/^@/u, ""),
  configError: api.configError,
  configWarning: api.configWarning,
};
